import React from "react";
import { node } from "prop-types";
import { Col, Container, Row } from "../../../Grid";
import Heading from "../../../Heading";
import Section from "../../../Section";
import { sxProps, sxPropTypes } from "../../../props/sx";
import pureProps from "../../../utils/pureProps";
import { spacingProps, spacingPropTypes } from "../../../props/spacing";

const signInUtilityProps = {
	bgColor: "black--02",
	sm: {
		border: {
			top: {
				width: 1,
				color: "black--10",
			},
		},
	},
	md: {
		border: {
			top: {
				width: 0,
			},
			left: {
				width: 1,
				color: "black--10",
			},
		},
	},
};

export const AuthContainerSignIn = ({ children, ...props }) => {
	return (
		<Col md={5} id="signInSection" spacing={{ py: 16 }} utility={signInUtilityProps} {...props}>
			<Row utility={{ justify: "center" }}>
				<Col md={9}>{children}</Col>
			</Row>
		</Col>
	);
};

AuthContainerSignIn.propTypes = {
	children: node.isRequired,
};

export const AuthContainerSignUp = ({ children }) => {
	return (
		<Col id="signUpSection" md={7} spacing={{ py: 16 }} utility={{ bgColor: "white" }}>
			<Row utility={{ justify: "center" }}>
				<Col md={10}>{children}</Col>
			</Row>
		</Col>
	);
};

AuthContainerSignUp.propTypes = {
	children: node.isRequired,
};

export const AuthContainerTitle = ({
	weight,
	sx = { ...sxProps },
	spacing = { ...spacingProps },
	className = "",
	children,
	...props
}) => {
	return (
		<Heading
			Tag="h2"
			sx={{ fontSize: "xl", fontWeight: weight, textAlign: "center", ...pureProps(sx) }}
			spacing={{ mb: 10, ...pureProps(spacing) }}
			className={className}
			{...props}
		>
			{children}
		</Heading>
	);
};

AuthContainerTitle.propTypes = {
	sx: sxPropTypes,
	spacing: spacingPropTypes,
	...Heading.propTypes,
};

const AuthContainer = ({ children }) => {
	return (
		<Section>
			<Container>
				<Row px>{children}</Row>
			</Container>
		</Section>
	);
};

AuthContainer.propTypes = {
	children: node.isRequired,
};

export default AuthContainer;
